// extracted by mini-css-extract-plugin
export default {"list":"MeetingJournalPage_list__eeJ2D"};